import React from 'react';
import '../Home/Home.css';
import Slide from '../../Components/Sliders/Slide';
import Fcard from '../../Components/Founders/Fcard';
import Welcome from '../../Components/Welcomes/Welcome';
import Videoplayer from '../../Components/Videoplayer/Videoplayer';
import Acard from '../../Components/Aboutschool/Acard';
import Fecard from '../../Components/Features/Fecard'
import Admregister from "../../Components/Admregister/Admregister";
import News from '../../Components/News/News';

const Home = () => {
  return (
    <div>     
       <Admregister/>
       <Slide/>
       <Welcome/>
       <Fcard/>
       <Videoplayer/>
       <Acard/>
       <Fecard/>  
       <News />  
    </div>
  )
}

export default Home
